class ZendeskLauncher extends HTMLElement {
  constructor() {
    super();
    this.initialIconLoaded = false;
    this.zendeskReady = false;
    this.isMessengerOpen = false;
  }

  connectedCallback() {
    this.render();
    this.setupEventListeners();
  }

  render() {
    const iconInitialUrl = this.getAttribute('data-icon-initial');
    const iconLoadedUrl = this.getAttribute('data-icon-loaded');
    const iconOpenUrl = this.getAttribute('data-icon-open');
    const iconWidth = this.getAttribute('data-icon-width');
    const iconHeight = this.getAttribute('data-icon-height');
    const text = this.getAttribute('data-text');

    const finalLoadedUrl = iconLoadedUrl && iconLoadedUrl !== 'null' && iconLoadedUrl.trim() !== '' 
      ? iconLoadedUrl 
      : iconInitialUrl;
    
    const finalOpenUrl = iconOpenUrl && iconOpenUrl !== 'null' && iconOpenUrl.trim() !== '' 
      ? iconOpenUrl 
      : iconInitialUrl;

    this.innerHTML = `
      <div class="zendesk-launcher-container zendesk-launcher-container--closed">
        <div class="zendesk-custom-launcher__icon-container">
          <img 
            class="zendesk-icon-initial" 
            src="${iconInitialUrl}" 
            width="${iconWidth}" 
            height="${iconHeight}"
            alt="Zendesk Icon">
          <img 
            class="zendesk-icon-loaded" 
            src="${finalLoadedUrl}" 
            width="${iconWidth}" 
            height="${iconHeight}"
            alt="Zendesk Icon Loaded">
        </div>
        <span class="zendesk-custom-launcher__text">${text}</span>
      </div>
      <div class="zendesk-launcher-container zendesk-launcher-container--open">
        <div class="zendesk-custom-launcher__icon-container">
          <img 
            class="zendesk-icon-open" 
            src="${finalOpenUrl}" 
            width="${iconWidth}" 
            height="${iconHeight}"
            alt="Zendesk Icon Open">
        </div>
      </div>
    `;
  }

  setupEventListeners() {
    const initialIcon = this.querySelector('.zendesk-icon-initial');

    initialIcon.addEventListener('load', () => {
      this.initialIconLoaded = true;
      this.checkAndAnimate();
    });

    this.addEventListener('click', () => {
      if (typeof zE !== 'undefined') {
        if (this.isMessengerOpen) {
          zE('messenger', 'close');
        } else {
          zE('messenger', 'open');
        }
      }
    });

    window.addEventListener('load', () => {
      this.initializeZendesk();
    });
  }

  initializeZendesk() {
    const setupZendesk = () => {
      zE('messenger', 'close');

      zE('messenger:on', 'open', () => {
        this.isMessengerOpen = true;
        this.classList.add('messenger-open');
      });

      zE('messenger:on', 'close', () => {
        this.isMessengerOpen = false;
        this.classList.remove('messenger-open');
      });

      this.zendeskReady = true;
      this.checkAndAnimate();
    };

    if (typeof window.zE !== 'undefined') {
      setupZendesk();
      return;
    }

    const zendeskScript = document.getElementById('ze-snippet');
    if (zendeskScript) {
      zendeskScript.addEventListener('load', setupZendesk);
      
      if (zendeskScript.complete || typeof window.zE !== 'undefined') {
        setupZendesk();
      }
    } else {
      //Retry to check if zendesk is ready for 10 times
      let attempts = 0;
      const checkInterval = setInterval(() => {
        attempts++;
        if (typeof window.zE !== 'undefined') {
          clearInterval(checkInterval);
          setupZendesk();
        } else if (attempts >= 10) {
          clearInterval(checkInterval);
          this.zendeskReady = true;
          this.checkAndAnimate();
        }
      }, 250);
    }
  }

  checkAndAnimate() {
    if (!this.initialIconLoaded || !this.zendeskReady || this.timer) return;

    const ms = parseInt(this.getAttribute('data-delay-ms'), 10);
    const delay = Number.isFinite(ms) && ms >= 0 ? ms : 30000;

    this.timer = setTimeout(() => {
      this.timer = null;
      this.classList.remove('hidden');

      const loadedIcon = this.querySelector('.zendesk-icon-loaded');
      if (loadedIcon && !loadedIcon.classList.contains('filling')) {
        setTimeout(() => {
          loadedIcon.classList.add('filling');
        }, 100);
      }
    }, delay);
  }
}

customElements.define('zendesk-launcher', ZendeskLauncher);
